const FechamentoComponent = () => {
    return(
        <div>FechamentoComponent</div>
    )
}
export default FechamentoComponent;